@let agreementDialogDocument = this.agreementDialogDocument();
@let hideAcceptBtn = this.hideAcceptBtn();

<div #reader class="reader" [class.markdown]="agreementDialogDocument.type === agreementDocumentType.Text">
    @if (agreementDialogDocument.type === agreementDocumentType.Text) {
        <markdown class="agreement-content" [data]="agreementDialogDocument.content" />
    }

    @if (agreementDialogDocument.type === agreementDocumentType.Pdf) {
        <warema-pdf-viewer
            [filenameForDownload]="'agreement'"
            [showPrintButton]="false"
            [src]="agreementDialogDocument.content"
            [trackScrolling]="!hideAcceptBtn"
            (scrolledToBottom)="scrolledToBottom.set(true)"
        />
    }
</div>

<div class="action-buttons">
    <warema-button type="tertiary" [text]="'PRINT' | translate" (click)="printAgreement()" />
    <warema-button type="tertiary" [text]="'CANCEL' | translate" (click)="popupResult$?.next(false)" />
    @if (!hideAcceptBtn) {
        <warema-button
            [disabled]="scrolledToBottom() === false"
            [text]="'ACCEPT' | translate"
            (click)="popupResult$?.next(true)"
        />
    }
</div>
